<div style="height:95vh">
 <iframe class="sun" [src]="iframUrl" *ngIf="iframUrl" marginwidth="0" marginheight="0" frameborder="0" width="100%" height="100%;" scrolling="yes" allowfullscreen="allowfullscreen"></iframe>
</div>
<app-footer></app-footer>